import YandexGoals from 'www/modules/YandexGoals'

const yandexGoalsInstance = new YandexGoals()

function sendYaGoal(name) {
  yandexGoalsInstance.send({ name })
}

export default sendYaGoal
